<template>
  <vs-popup class="add-new-carrier"
            id="popup"
            title="CREATE CUSTOMER SOURCE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form id="create-carrier-popup" @submit.prevent="handleSubmit(onClickCreateIndustrialSector)" autocomplete="off">

        <div class="mb-3 vx-row">
          <div class="w-full vx-col md:w-full md:mb-0">
            <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
              <small class="label">Name</small>
              <vs-input v-model="form.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row ml-1">
        <span class="label">Sub sources</span>
        </div>
        <div v-for="(sector,index) in form.sub_sources">
          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-5/6 md:mb-0">
              <ValidationProvider :vid="`sub_sector_name${index}`" :name="`sub_sector_name${index}`" rules="required" v-slot="{ errors }">
                <vs-input v-model="form.sub_sources[index].name"  :name="`sub_sector_name${index}`" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="w-full vx-col md:w-1/6 md:mb-0 mt-1 ">
              <vs-button @click = "removeSubSection(index)" class="ml-3"
                         size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
            </div>
          </div>
        </div>
        <vs-button @click="addNewSubSector" class="mt-2 ml-auto" size="small">Add new sub source</vs-button>
        <div class="flex flex-wrap items-center justify-end mt-8">
          <vs-button button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
          <vs-button @click="clearForm" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
        </div>
      </form>
    </ValidationObserver>

  </vs-popup>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

const CustomerSourceRepository = RepositoryFactory.get('customer_source')


function initialState() {
  return {
    open: false,
    form: {
      parent_id: null,
      name: '',
      sub_sources:[
        { name: '' }
      ]
    },
  }
}
export default {
  name: "CreateCustomerSourcePopup",
  data(){
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods:{
    async openPopup() {
        Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
    },
    addNewSubSector(){
      this.form.sub_sources.push({
        name:''
      })
    },
    async onClickCreateIndustrialSector(){
      await this.$vs.loading()
      const vue = this
      try {
        await CustomerSourceRepository.createCustomerSource(this.form)
        this.showSuccessMessage('Customer source created successfully');
        vue.$parent.refreshData()
        this.open = false
      }catch (error){
        this.$vs.loading.close()
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    clearForm(){
      this.form = {
        parent_id: null,
        name: '',
        sub_sources:[]
      }
    },
    removeSubSection(index){
      this.form.sub_sources.splice(index,1)
    }
  }

}
</script>

<style scoped>

</style>
